
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Ventures', href: '/ventures' },
    { name: 'Experience', href: '/experience' },
    { name: 'Writing', href: '/writing' },
    { name: 'Speaking', href: '/speaking' },
    { name: 'Contact', href: '/contact' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gold rounded-full flex items-center justify-center">
              <span className="text-navy font-sora font-bold text-lg">HA</span>
            </div>
            <img 
              src="https://public.readdy.ai/ai/img_res/0a59dd37-0c5e-4d51-b933-732190cdb694.jpg"
              alt="Henry Olamide Adebisi"
              className="w-10 h-10 rounded-full object-cover object-top"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`font-inter font-medium transition-colors duration-200 ${
                  isActive(item.href)
                    ? 'text-navy border-b-2 border-gold pb-1'
                    : 'text-gray-600 hover:text-navy'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Button variant="secondary" size="sm" href="/contact">
              Book Henry
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-600 hover:text-navy"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`font-inter font-medium py-2 transition-colors duration-200 ${
                    isActive(item.href) ? 'text-navy' : 'text-gray-600 hover:text-navy'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Button variant="secondary" size="sm" href="/contact" className="w-fit">
                Book Henry
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
